var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Loading } from 'element-ui';
import { Component, Watch } from 'vue-property-decorator';
import LicenseService from "../../api/LicenseService";
import BindGoodsHeader from "./components/BindGoodsHeader.vue";
import { auth } from "../../helper/authDecorator";
import { nameDict } from "../../constant/authCode";
var SeeBindGoods = (function (_super) {
    __extends(SeeBindGoods, _super);
    function SeeBindGoods() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.row = {};
        _this.document_id = '';
        _this.tableHeight = 300;
        _this.tableData = [];
        _this.selectedData = [];
        _this.filter = { dimension: 1 };
        _this.total = 0;
        return _this;
    }
    SeeBindGoods.prototype.watchActiveName = function (newValue, oldValue) {
        var _this = this;
        this.$nextTick(function () {
            _this.$refs.table.doLayout();
        });
    };
    SeeBindGoods.prototype.created = function () {
        this.service = LicenseService.getInstance();
    };
    SeeBindGoods.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.$el && _this.$el.parentElement) {
                _this.tableHeight = _this.$el.parentElement.clientHeight - 160 - 40;
            }
        }, 300);
    };
    SeeBindGoods.prototype.selectionChange = function (val) {
        this.selectedData = val;
    };
    SeeBindGoods.prototype.search = function (filter) {
        this.$refs.pagination.clear();
        this.filter = filter;
        this.getList();
    };
    SeeBindGoods.prototype.getList = function (pager) {
        var _this = this;
        pager = pager ? pager : this.$refs.pagination.getPage();
        var params = {
            document_id: this.document_id
        };
        Object.assign(params, this.filter, pager);
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getDocumentAlreadyBindGoods(params).then(function (res) {
            loadingInstance.close();
            if (res.data.success) {
                _this.tableData = res.data.data;
                _this.total = res.data.total;
                window._czc.push(["_trackEvent", '证照管理', '查看绑定货品']);
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    SeeBindGoods.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    SeeBindGoods.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (!prop) {
            this.order = null;
        }
        else {
            this.order = [prop, order === 'ascending' ? 'asc' : 'desc'];
        }
        this.getList();
    };
    SeeBindGoods.prototype.unBindGoods = function (document_id) {
        var _this = this;
        if (!this.selectedData.length) {
            this.$message.error("请选择货品");
            return;
        }
        var goods_ids = this.selectedData.map(function (v) { return v.goods_id; });
        var params = {
            document_id: this.document_id,
            goods_ids: goods_ids.join(',')
        };
        var html = "<div>\u786E\u5B9A\u8981\u89E3\u7ED1\u4EE5\u4E0B\u8D27\u54C1\u5417\uFF1F<br/> " + this.selectedData.map(function (v) { return v.goods_name; }).join('<br/>') + "</div>";
        this.$confirm(html, '提示', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            customClass: 'message-h-40vh'
        }).then(function (result) {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.documentUnBindGoods(params).then(function (res) {
                loadingInstance.close();
                if (res.data.success) {
                    _this.$message.success("解绑成功");
                    _this.getList();
                    window._czc.push(["_trackEvent", '证照管理', '解绑货品']);
                    if (_this.opener) {
                        _this.opener.search();
                    }
                }
                else {
                    _this.$message.error(res.data.msg);
                }
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.message || err.msg);
            });
        }).catch(function (err) {
            console.log(err);
        });
    };
    SeeBindGoods.prototype.unBindGoodsFormat = function (document_id) {
        var _this = this;
        if (!this.selectedData.length) {
            this.$message.error("请选择货品规格");
            return;
        }
        var goods_format_ids = this.selectedData.map(function (v) { return v.goods_format_id; });
        var params = {
            document_id: this.document_id,
            goods_format_ids: goods_format_ids.join(',')
        };
        var html = "<div>\u786E\u5B9A\u8981\u89E3\u7ED1\u4EE5\u4E0B\u8D27\u54C1\u89C4\u683C\u5417\uFF1F<br/> " + this.selectedData.map(function (v) { return v.goods_format_name; }).join('<br/>') + "</div>";
        this.$confirm(html, '提示', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            customClass: 'message-h-40vh'
        }).then(function (result) {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.documentUnBindGoodsFormat(params).then(function (res) {
                loadingInstance.close();
                if (res.data.success) {
                    _this.$message.success("解绑成功");
                    _this.getList();
                    window._czc.push(["_trackEvent", '证照管理', '解绑货品规格']);
                    if (_this.opener) {
                        _this.opener.search();
                    }
                }
                else {
                    _this.$message.error(res.data.msg);
                }
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.message || err.msg);
            });
        }).catch(function (err) {
            console.log(err);
        });
    };
    __decorate([
        Watch("filter.dimension")
    ], SeeBindGoods.prototype, "watchActiveName", null);
    SeeBindGoods = __decorate([
        auth(nameDict["证照管理"], true),
        Component({
            components: {
                'list-header': BindGoodsHeader
            }
        })
    ], SeeBindGoods);
    return SeeBindGoods;
}(Vue));
export default SeeBindGoods;
